/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Nome comum:" label-for="input-1">
            <b-form-input
              v-model="cultura.nome_comum"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Nome científico:" label-for="input-1">
            <b-form-input
              v-model="cultura.nome_cientifico"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Código Siagro:" label-for="input-1">
            <b-form-input
              v-model="cultura.cod_siagro"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Código Siagro 2:" label-for="input-1">
            <b-form-input
              v-model="cultura.cod_siagro2"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Classe:" label-for="input-1">
            <b-form-textarea
              v-model="cultura.class_sc"
              type="text"
              no-resize
              required
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Manejo 1:" label-for="input-1">
            <b-form-textarea
              v-model="cultura.manejo_1"
              type="text"
              no-resize
              required
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Manejo 2:" label-for="input-1">
            <b-form-textarea
              v-model="cultura.manejo_2"
              type="text"
              no-resize
              required
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Tipo Aplicação" label-for>
            <v-select
              label="nome"
              :options="tipos_aplicacao"
              :reduce="(item) => item.id_tipo_aplicacao"
              v-model="cultura.id_tipo_aplicacao"
            >
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Código SIGA:" label-for="input-1">
            <b-form-input
              v-model="cultura.cod_siga"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <b-button type="submit" variant="success" @click.prevent="salvarCultura"
        >Salvar</b-button
      >
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Cultura from '@src/services/culturas'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

import TipoAplicacao from '@src/services/tipo-aplicacao'

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    cultura: {},
  },
  data() {
    return {
      tipos_aplicacao: [],
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
    }
  },
  created() {},
  mounted() {
    this.handleGet()
  },
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      TipoAplicacao.listar(token).then((response) => {
        this.tipos_aplicacao = response.data.dados
      })
    },
    salvarCultura() {
      const token = this.$store.state.auth.currentUser.token
      if (this.cultura.id_cultura) {
        this.isLoading = this.loading(this.isLoading)
        Cultura.update(token, this.cultura)
          .then((resposta) => {
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        Cultura.salvar(token, this.cultura)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.cultura = {}
          })
          .catch((erro) => {
            console.log(erro)
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              erro.response ? erro.response.data.data : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.isLoading = this.loading(false)
          })
      }
    },
  },
}
</script>

<style>
</style>